import {
    AUTOSHIP_ONE_TIME_OPTION,
    AUTOSHIP_ONE_TIME_SELECTION_VALUE,
    getAutoshipFrequencyOptions,
} from '@libs/common-types';

export const MOST_COMMON_LABEL_SUFFIX = ' (most common)';

export type AutoshipFrequencyItem = {
    label: string;
    value: string;
};

type GetAutoshipFrequencyItemsParams = {
    withOneTime: boolean;
    mostCommonValue?: string;
    as_freq_5_7: boolean;
};

/**
 * Builds the "Ships every" select items: the visible cadences (5 and 7 weeks behind `as_freq_5_7`),
 * the "(most common)" suffix on `mostCommonValue`, and an optional leading "One-time" option.
 */
export const getAutoshipFrequencyItems = ({
    withOneTime,
    mostCommonValue,
    as_freq_5_7,
}: GetAutoshipFrequencyItemsParams): AutoshipFrequencyItem[] => {
    const recurringFrequencyItems = getAutoshipFrequencyOptions(as_freq_5_7).map(item => ({
        ...item,
        label: item.value === mostCommonValue ? `${item.label}${MOST_COMMON_LABEL_SUFFIX}` : item.label,
    }));

    return withOneTime
        ? [
              {
                  label: AUTOSHIP_ONE_TIME_OPTION.label,
                  value: AUTOSHIP_ONE_TIME_SELECTION_VALUE,
              },
              ...recurringFrequencyItems,
          ]
        : recurringFrequencyItems;
};
